import { Link } from 'react-router-dom';

export default function InvestorCTASection() {
  return (
    <section className="relative py-20 md:py-28 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-14 md:mb-18">
          <span className="text-[10px] uppercase tracking-[3px] text-primary-500 font-semibold">
            Partner With Us
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 mt-4 mb-5 tracking-tight">
            Institutional-Grade<br />Investment Access
          </h2>
          <p className="text-foreground-500 text-base max-w-xl mx-auto leading-relaxed">
            We partner with institutional investors, family offices, sovereign wealth funds, and accredited professionals seeking diversified exposure to high-conviction opportunities.
          </p>
        </div>

        {/* Two Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {/* Institutional */}
          <div className="bg-white rounded-2xl p-8 md:p-10 border border-foreground-100/30 hover:border-primary-300/40 transition-all duration-500">
            <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-6">
              <i className="ri-bank-line text-2xl text-primary-600" />
            </div>
            <h3 className="text-xl font-heading font-bold text-foreground-950 mb-3">
              Institutional Investors
            </h3>
            <p className="text-foreground-500 text-sm leading-relaxed mb-6">
              Access our full portfolio of diversified investments with co-investment structures, segregated mandates, and custom fund vehicles tailored to your allocation strategy.
            </p>
            <ul className="flex flex-col gap-2.5 mb-8">
              {[
                'Minimum commitment: €500K',
                'Quarterly performance reports',
                'Co-investment opportunities',
                'Dedicated relationship manager',
              ].map((item) => (
                <li key={item} className="flex items-start gap-2.5">
                  <i className="ri-checkbox-circle-fill text-primary-500 text-sm mt-0.5 shrink-0" />
                  <span className="text-foreground-600 text-sm">{item}</span>
                </li>
              ))}
            </ul>
            <Link
              to="/investor-relations"
              className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 text-sm uppercase tracking-[2px] font-semibold transition-colors cursor-pointer"
            >
              Institutional Access
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          {/* Professional */}
          <div className="bg-white rounded-2xl p-8 md:p-10 border border-foreground-100/30 hover:border-primary-300/40 transition-all duration-500">
            <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-6">
              <i className="ri-user-star-line text-2xl text-accent-600" />
            </div>
            <h3 className="text-xl font-heading font-bold text-foreground-950 mb-3">
              Professional Investors
            </h3>
            <p className="text-foreground-500 text-sm leading-relaxed mb-6">
              Accredited individual investors and family offices can participate in select investment vehicles with transparent reporting and Swiss-grade investor protections.
            </p>
            <ul className="flex flex-col gap-2.5 mb-8">
              {[
                'Minimum commitment: €100K',
                'Semi-annual investor updates',
                'Digital investor portal access',
                'Annual general meeting invitation',
              ].map((item) => (
                <li key={item} className="flex items-start gap-2.5">
                  <i className="ri-checkbox-circle-fill text-accent-500 text-sm mt-0.5 shrink-0" />
                  <span className="text-foreground-600 text-sm">{item}</span>
                </li>
              ))}
            </ul>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 text-accent-600 hover:text-accent-700 text-sm uppercase tracking-[2px] font-semibold transition-colors cursor-pointer"
            >
              Request Investor Kit
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>

        {/* Bottom Trust Line */}
        <div className="mt-16 text-center">
          <p className="text-foreground-300 text-xs italic max-w-lg mx-auto">
            Swiss Microfinance Holding SA is registered in Switzerland under CH-217.3.537.260-9. Past performance does not guarantee future results. For professional and accredited investors only.
          </p>
        </div>
      </div>
    </section>
  );
}